import {priceHelper} from '../../config-master.mjs';
import {convertJsDateToShortDate} from '../../common/date.mjs';
import {roundMoneyFair} from '@helpers/common/number.mjs';

export const generalSingleProductNonVariantJsonLD = (selectedVariant, reviewsFromDb, seoTitle, seoDescription, options = {}) => {
  // console.log('[generalSingleProductNonVariantJsonLD] selectedVariant:', selectedVariant);
  const brand = 'Skar Audio';

  const isTrueVariantSku = selectedVariant?.product_type === 'variant';
  // console.log("[generalSingleProductNonVariantJsonLD] isTrueVariantSku:", isTrueVariantSku);

  const reviewsAggregateAvgScore = reviewsFromDb?.avgScore > 0 ? roundMoneyFair(reviewsFromDb?.avgScore) : null;
  const reviewsAggregateCount = reviewsFromDb?.count;

  const futureDate = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365 * 5);
  const priceValidUntil = convertJsDateToShortDate(futureDate);

  const productVariants = selectedVariant?.variants ?? [selectedVariant];

  const mainImage = options?.mainImage ?? selectedVariant?.images?.[0]?.url ?? options?.matchingVariant?.images?.[0]?.url;

  let currentlyInStock = selectedVariant?.currentlyInStock;
  const itemCondition = 'https://schema.org/NewCondition';
  const baseUrl = `https://www.skaraudio.com`;

  let variantOffers = productVariants?.map((variant) => {
    const sku = variant?.sku;
    const upc = variant?.upc;
    const gtin12 = upc;

    const currentPrice = variant?.price ?? priceHelper?.getFinalPrice(variant);
    const pathUrl = variant?.path;

    let variantUrl = `${baseUrl}${pathUrl}`;
    let url = new URL(variantUrl);
    let variantUrlWithoutQuery = url.origin + url.pathname;

    if (!currentlyInStock) {
      currentlyInStock = variant?.currentlyInStock;
    }

    let availability = currentlyInStock ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock';
    const isPreOrderEligible =
      selectedVariant?.pre_order_info?.is_pre_order_eligible && selectedVariant?.pre_order_info?.is_pre_order_enabled;
    if (isPreOrderEligible) {
      availability = 'https://schema.org/PreOrder';
    }

    const variantOffer = {
      '@type': 'Offer',
      sku: sku,
      mpn: sku,
      url: variantUrlWithoutQuery,
      gtin: upc,
      gtin12: gtin12,
      price: currentPrice,
      priceCurrency: 'USD',
      priceValidUntil: priceValidUntil,
      itemCondition: itemCondition,
      availability: availability,
      hasMerchantReturnPolicy: {
        '@type': 'MerchantReturnPolicy',
        applicableCountry: 'US',
        returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
        merchantReturnDays: 30,
        returnMethod: 'https://schema.org/ReturnByMail',
        returnFees: 'https://schema.org/FreeReturn'
      },
      shippingDetails: {
        '@type': 'OfferShippingDetails',
        shippingRate: {
          '@type': 'MonetaryAmount',
          value: 0.0,
          currency: 'USD'
        },
        shippingDestination: {
          '@type': 'DefinedRegion',
          addressCountry: 'US'
        },
        deliveryTime: {
          '@type': 'ShippingDeliveryTime',
          handlingTime: {
            '@type': 'QuantitativeValue',
            minValue: 0,
            maxValue: 1,
            unitCode: 'DAY'
          },
          transitTime: {
            '@type': 'QuantitativeValue',
            minValue: 1,
            maxValue: 3,
            unitCode: 'DAY'
          }
        }
      }
    };
    return variantOffer;
  });

  let jsonLdProductData = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: seoTitle,
    image: [mainImage],
    brand: {'@type': 'Brand', name: brand},
    description: seoDescription
  };

  if (!isTrueVariantSku) {
    jsonLdProductData.sku = selectedVariant?.sku;
    jsonLdProductData.mpn = selectedVariant?.sku;
    jsonLdProductData.gtin = selectedVariant?.upc;
    jsonLdProductData.gtin12 = selectedVariant?.upc;
    jsonLdProductData.offers = variantOffers?.[0];
  }

  if (reviewsAggregateAvgScore > 0 && reviewsAggregateCount > 0) {
    jsonLdProductData.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: reviewsAggregateAvgScore,
      reviewCount: reviewsAggregateCount
    };
  }
  // console.log('[generalSingleProductNonVariantJsonLD] jsonLdProductData:', jsonLdProductData);
  return jsonLdProductData;
};
